import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import TableCell from 'components/TableCell';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';

import { ServiceGroupsListRow_serviceGroup$key } from '__generated__/ServiceGroupsListRow_serviceGroup.graphql';

type Props = EntityTableRowProps & {
  serviceGroup: ServiceGroupsListRow_serviceGroup$key;
};

const ServiceGroupsListRow: FC<Props> = ({ serviceGroup, ...props }) => {
  const serviceGroupData = useFragment(
    graphql`
      fragment ServiceGroupsListRow_serviceGroup on ServiceGroup {
        id
        name

        ...EntityTableRow_entity
      }
    `,
    serviceGroup
  );

  const { id, name } = serviceGroupData;

  return (
    <EntityTableRow entity={serviceGroupData} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>
    </EntityTableRow>
  );
};

export default ServiceGroupsListRow;
